/**
 * Immutably toggles an ID in a readonly array.
 *
 * Adds the ID if absent, removes it if present. Returns a new array.
 * @module features/scouting/utils/toggleId
 */

/**
 * Toggles an ID in an immutable array -- adds if absent, removes if present.
 * @param ids - Current array of IDs
 * @param id - ID to toggle
 * @returns New array with the ID toggled
 */
function toggleId(ids: readonly string[], id: string): readonly string[] {
  return ids.includes(id) ? ids.filter(i => i !== id) : [...ids, id];
}

export default toggleId;
